<h1 class="mb-4">Edycja komunikatu</h1>

@if (formGroup()) {
  <form [formGroup]="formGroup()!" (ngSubmit)="onSave()">
    <p-card header="Dane podstawowe" class="custom-card">
      <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div class="flex flex-col gap-2">
          <label for="announcement-id" appRequiredLabel="id" class="field-label"
            >Identyfikator</label
          >
          <input
            id="announcement-id"
            pInputText
            formControlName="id"
            readonly
          />
        </div>
        <div class="flex flex-col gap-2">
          <label
            for="announcement-created-at"
            appRequiredLabel="createdAt"
            class="field-label"
            >Data utworzenia</label
          >
          <p-date-picker
            inputId="announcement-created-at"
            class="w-full customDatePicker"
            dateFormat="yy-mm-dd"
            [showTime]="true"
            hourFormat="24"
            [readonlyInput]="true"
            [showIcon]="true"
            [iconDisplay]="'input'"
            appendTo="body"
            [formControl]="formGroup()!.controls.createdAt"
          ></p-date-picker>
        </div>
      </div>

      <div class="grid grid-cols-1 md:grid-cols-3 gap-6 mt-6">
        <div class="flex flex-col gap-2">
          <label
            for="announcement-title"
            appRequiredLabel="title"
            class="field-label"
            >Tytuł</label
          >
          <input
            id="announcement-title"
            pInputText
            formControlName="title"
            appControlError
          />
        </div>
      </div>

      <div class="mt-6 flex flex-col gap-2">
        <span
          id="announcement-content-label"
          appRequiredLabel="content"
          class="field-label"
          >Treść</span
        >
        <div appRemoveQuillTooltip>
          <p-editor
            id="announcement-content"
            [formControl]="formGroup()!.controls.content"
            [style]="{ height: '200px' }"
            class="announcement-editor"
            appQuillListMarkerStyle
            appControlError
            aria-labelledby="announcement-content-label"
          >
            <ng-template pTemplate="header">
              <span class="ql-formats">
                <select class="ql-size" aria-label="Wielkość czcionki">
                  <option value="small">mała</option>
                  <option selected>średnia</option>
                  <option value="large">duża</option>
                </select>
              </span>
              <span class="ql-formats">
                <button
                  class="ql-bold"
                  aria-label="Pogrubienie"
                  type="button"
                ></button>
                <button
                  class="ql-italic"
                  aria-label="Pochylenie"
                  type="button"
                ></button>
                <button
                  class="ql-underline"
                  aria-label="Podkreślenie"
                  type="button"
                ></button>
              </span>
              <span class="ql-formats">
                <select class="ql-color" aria-label="Kolor czcionki"></select>
              </span>
              <span class="ql-formats">
                <button
                  class="ql-list"
                  value="ordered"
                  aria-label="Numerowanie"
                  type="button"
                ></button>
                <button
                  class="ql-list"
                  value="bullet"
                  aria-label="Wypunktowanie"
                  type="button"
                ></button>
              </span>
              <span class="ql-formats">
                <select class="ql-align" aria-label="Wyrównanie tekstu">
                  <option selected></option>
                  <option value="center"></option>
                  <option value="right"></option>
                  <option value="justify"></option>
                </select>
              </span>
            </ng-template>
          </p-editor>
        </div>
      </div>

      <div class="grid grid-cols-1 md:grid-cols-3 gap-6 mt-6">
        <div class="flex flex-col gap-2">
          <span appRequiredLabel="status" class="field-label">Status</span>
          <div class="field-value">
            <span [ngClass]="statusPillClass()">
              {{ statusLabel() }}
            </span>
          </div>
        </div>
        <div class="flex flex-col gap-2">
          <span appRequiredLabel="channel" class="field-label">Kanał</span>
          <p-select
            class="w-full"
            [options]="channelOptions"
            optionLabel="label"
            optionValue="value"
            appendTo="body"
            [formControl]="formGroup()!.controls.channel"
            appControlError
            ariaLabel="Wybierz kanał"
          ></p-select>
        </div>
        @if (shouldShowSystemFields()) {
          <div class="flex flex-col gap-2">
            <span appRequiredLabel="requiresConfirmation" class="field-label"
              >Wymaga potwierdzenia</span
            >
            <p-select
              class="w-full"
              [options]="confirmationOptions"
              optionLabel="label"
              optionValue="value"
              appendTo="body"
              [formControl]="formGroup()!.controls.requiresConfirmation"
              appControlError
              ariaLabel="Wymaga potwierdzenia"
            ></p-select>
          </div>
        }
      </div>

      @if (shouldShowSystemFields() || shouldShowEmailFields()) {
        <div class="grid grid-cols-1 md:grid-cols-3 gap-6 mt-6">
          @if (shouldShowSystemFields()) {
            <div class="flex flex-col gap-2">
              <label
                for="announcement-start-date"
                appRequiredLabel="startDate"
                class="field-label"
                >Data rozpoczęcia</label
              >
              <p-date-picker
                inputId="announcement-start-date"
                class="w-full customDatePicker"
                dateFormat="yy-mm-dd"
                [showTime]="true"
                hourFormat="24"
                [readonlyInput]="true"
                [showIcon]="true"
                [iconDisplay]="'input'"
                appendTo="body"
                [maxDate]="formGroup()!.controls.endDate.value ?? null"
                [formControl]="formGroup()!.controls.startDate"
                appControlError
              ></p-date-picker>
            </div>
            <div class="flex flex-col gap-2">
              <label
                for="announcement-end-date"
                appRequiredLabel="endDate"
                class="field-label"
                >Data wygaśnięcia</label
              >
              <p-date-picker
                inputId="announcement-end-date"
                class="w-full customDatePicker"
                dateFormat="yy-mm-dd"
                [showTime]="true"
                hourFormat="24"
                [readonlyInput]="true"
                [showIcon]="true"
                [iconDisplay]="'input'"
                appendTo="body"
                [minDate]="formGroup()!.controls.startDate.value ?? null"
                [formControl]="formGroup()!.controls.endDate"
                appControlError
              ></p-date-picker>
            </div>
          }
          @if (shouldShowEmailFields()) {
            <div class="flex flex-col gap-2">
              <label
                for="announcement-email-date"
                appRequiredLabel="plannedEmailSendAt"
                class="field-label"
                >Planowana data wysłania wiadomości mailowych</label
              >
              <p-date-picker
                inputId="announcement-email-date"
                class="w-full customDatePicker"
                dateFormat="yy-mm-dd"
                [showTime]="true"
                hourFormat="24"
                [readonlyInput]="true"
                [showIcon]="true"
                [iconDisplay]="'input'"
                appendTo="body"
                [minDate]="today"
                [formControl]="formGroup()!.controls.plannedEmailSendAt"
                appControlError
              ></p-date-picker>
            </div>
          }
        </div>
      }

      <div class="grid grid-cols-1 md:grid-cols-3 gap-6 mt-6">
        <div class="flex flex-col gap-2">
          <span appRequiredLabel="recipientType" class="field-label"
            >Typ adresata</span
          >
          <p-select
            class="w-full"
            [options]="recipientTypeOptions"
            optionLabel="label"
            optionValue="value"
            appendTo="body"
            [formControl]="formGroup()!.controls.recipientType"
            appControlError
            ariaLabel="Wybierz typ adresata"
          ></p-select>
        </div>
        @if (shouldShowRequestType()) {
          <div class="flex flex-col gap-2">
            <span appRequiredLabel="requestCode" class="field-label"
              >Kod wniosku</span
            >
            <p-select
              class="w-full"
              [options]="requestTypeOptions()"
              optionLabel="label"
              optionValue="value"
              appendTo="body"
              [formControl]="formGroup()!.controls.requestCode"
              appControlError
              ariaLabel="Wybierz kod wniosku"
            ></p-select>
          </div>
        }
      </div>
      @if (shouldShowRecipients()) {
        <app-announcement-recipients
          [recipients]="recipients()"
          [control]="formGroup()!.controls.recipients"
          (addRequested)="onSelectRecipients()"
          (removeRequested)="onRemoveRecipient($event)"
        ></app-announcement-recipients>
      }

      <div class="grid grid-cols-1 md:grid-cols-3 gap-6 mt-6">
        <div class="flex flex-col gap-2">
          <label
            for="announcement-created-by"
            appRequiredLabel="createdBy"
            class="field-label"
            >Utworzył</label
          >
          <input
            id="announcement-created-by"
            pInputText
            formControlName="createdBy"
            readonly
          />
        </div>
        <div class="flex flex-col gap-2">
          <label for="announcement-published-at" class="field-label"
            >Data opublikowania</label
          >
          <p-date-picker
            inputId="announcement-published-at"
            class="w-full customDatePicker"
            dateFormat="yy-mm-dd"
            [showTime]="true"
            hourFormat="24"
            [readonlyInput]="true"
            [showIcon]="true"
            [iconDisplay]="'input'"
            appendTo="body"
            [formControl]="formGroup()!.controls.publishedAt"
          ></p-date-picker>
        </div>
      </div>
    </p-card>

    <div class="flex flex-wrap justify-end gap-2 mt-6">
      <p-button
        type="button"
        label="Anuluj"
        styleClass="customInfoButton outlined"
        (click)="onCancel()"
      />
      <p-button
        label="Zapisz i zamknij"
        styleClass="customInfoButton"
        type="submit"
      />
    </div>
  </form>
}
